// extracted by mini-css-extract-plugin
export default {"main":"Main_main__SqrVH","sidebar":"Main_sidebar__jKicF","main_content":"Main_main_content__TmFae"};